import moment, { Moment } from 'moment';

export const MIN_ROLLING_WEEKS = 1;
export const MAX_ROLLING_WEEKS = 52;
export const DEFAULT_ROLLING_WEEKS = 13;

export const DATE_TYPE_FIXED = 'Fixed';
export const DATE_TYPE_ROLLING = 'Rolling';

export type DateRangeType = typeof DATE_TYPE_FIXED | typeof DATE_TYPE_ROLLING;

export const THROUGH_QUARTER_END_OPTION = 'Current Week Through End of Quarter';

interface RollingWindow {
    start: Moment;
    end: Moment;
}

/**
 * Resolve a forward-looking window of `weeks` broadcast weeks.
 *
 * `startOf('isoWeek')` (not `.day(1)`) is deliberate: moment's default locale
 * starts weeks on Sunday, so `.day(1)` on a Sunday jumps forward to the next
 * day and would skip the week the user is standing in. ISO weeks always start
 * Monday, matching the backend's `now - timedelta(days=weekday())`.
 */
export function getRollingWindow(weeks: number, from: Moment = moment()): RollingWindow {
    const start = from.clone().startOf('isoWeek').startOf('day');
    return {
        start,
        end: start.clone().add(weeks, 'weeks').subtract(1, 'day'),
    };
}

export function describeRollingWindow(weeks: number): string {
    const { start, end } = getRollingWindow(weeks);
    return `Showing the next ${weeks} ${weeks === 1 ? 'week' : 'weeks'} — currently ${start.format('M/D/YYYY')} – ${end.format('M/D/YYYY')}`;
}
